import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { ReferenceEntity } from "src/app/static-data/models/interfaces/static-data";
import { SettlementProvisionRecord } from "../../model/interfaces/credit-provision.interface";
import { ProductCaptureData } from "../../model/interfaces/product-capture.interface";

export function createSettlementProvisionFormGroup(referenceEntity: ReferenceEntity, product: ProductCaptureData, form: any): UntypedFormGroup {
  let creditProvisionId: number;
  let settlementData: SettlementProvisionRecord;
  let physicalSettlementMatrix = form?.['physicalSettlementMatrix'];
  
  if (product?.creditProvision) {
    creditProvisionId = product.creditProvision.id;
    settlementData = product.creditProvision.settlementProvisions.find(sp => sp.referenceEntityId === referenceEntity.referenceEntityID);
  }

  const group = new UntypedFormGroup({
    referenceEntityId: new UntypedFormControl(referenceEntity?.referenceEntityID),
    creditProvisionId: new UntypedFormControl(creditProvisionId),
    obligationCategory: new UntypedFormControl(settlementData?.obligationCategory),
    obligationCharacteristics: new UntypedFormControl(settlementData?.obligationCharacteristics),
    valuationObligationCategory: new UntypedFormControl(settlementData?.valuationObligationCategory),
    valuationObligationCharacteristics: new UntypedFormControl(settlementData?.valuationObligationCharacteristics),
    specifiedDomesticCurrency: new UntypedFormControl(settlementData ? settlementData.specifiedDomesticCurrency : referenceEntity?.currency),
    domesticCurrency: new UntypedFormControl(settlementData ? settlementData.domesticCurrency : referenceEntity?.domesticCurrency),
  });

  physicalSettlementMatrix && Object.keys(group.controls).forEach(key => group.get(key)['readOnly'] = true);

  return group;
}